import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Grid, Paper,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import actions from 'shared/actions';
import styles, { getTheme } from 'shared/styles';
import { getQueryParams } from 'shared/helpers';
import Username from './Login/Username';
import Password from './Login/Password';
import SignInButton from './Login/SignInButton';
import RateOnlySignup from './Login/RateOnlySignup';

export function LoginImpl({ interaction, onLoad, failedLogin }) {
  React.useEffect(onLoad, []);
  return (
    <div style={styles.mainBackground}>
      <form autoComplete="off" action={`/api/v1/oidc/interaction/${interaction}/login`} method="post">
        <Paper style={{
          padding: '25px',
          width: '300px',
          borderRadius: '0px',
        }}
        >
          <Grid container spacing={3} alignContent="flex-start">
            <Grid
              item
              xs={12}
              style={styles.logoBackground}
            >
              <img
                src={getTheme().logo}
                className="imglogo"
                alt="logo"
                style={{ width: '100%', height: 'auto' }}
              />
            </Grid>
            <RateOnlySignup />
            <Username failedLogin={failedLogin} />
            <Password failedLogin={failedLogin} />
            <SignInButton />
            <Grid item xs={12}>
              <Link style={styles.link} to="/forgot-password">Forgot Password</Link>
            </Grid>
          </Grid>

        </Paper>
      </form>
    </div>
  );
}

LoginImpl.propTypes = {
  interaction: PropTypes.string,
  failedLogin: PropTypes.string,
  onLoad: PropTypes.func.isRequired,
};

LoginImpl.defaultProps = {
  interaction: '',
  failedLogin: '',
};

export function mapStateToProps() {
  const params = getQueryParams();
  return {
    interaction: params.interaction,
    failedLogin: params.failedLogin,
  };
}

const mapDispatchToProps = {
  onLoad: actions.staging.onLoad,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginImpl);
